import { Input } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface SearchBarProps {
  handleChange?: (val: string) => void
  testId?: string
  value?: string
}

const InputBox = styled.div``;

export const SearchBar: React.FC<SearchBarProps> = ({
  handleChange = (val: string) => { },
  testId = 'search-field',
  value = ''
}) => {
  const { t } = useTranslation();

  return (
    <InputBox>
      <Input
        data-testid={testId}
        placeholder={t('general.searchByName')}
        aria-label={t('general.searchByName')}
        defaultValue={value}
        onChange={(event: any) => handleChange(event?.target?.value.trim())}
      />
    </InputBox>
  );
};
